import type { AgentShop } from '../../types';
import { accountStatus } from '@kioskgaming/ui';

export function shopStatusBadgeClass(status: AgentShop['status']) {
  const base = 'inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium';
  if (status === 'active') return `${base} bg-emerald-100 text-emerald-800`;
  if (status === 'suspended') return `${base} bg-amber-100 text-amber-900`;
  return `${base} bg-gray-200 text-gray-700`;
}

export function ShopStatusBadge({ status }: { status: AgentShop['status'] }) {
  return <span className={shopStatusBadgeClass(status)}>{accountStatus(status).label}</span>;
}
